import React from 'react';
import { Link } from 'react-router-dom'; // Added for client-side routing on internal links

const Identity = () => {
  return (
    <section className="identity">
      <div className="container">
        <h2>Your Decentralized Web3 Identity</h2>
        <p>Your ENS Domain like john.xbsys.eth, your decentralized account on the world computer—secure, private, owned by you forever.</p>
        <div className="identity-features">
          <div className="feature">
            <i className="fas fa-shield-alt"></i>
            <span>Secure Blockchain Identity</span>
          </div>
          <div className="feature">
            <i className="fas fa-user-secret"></i>
            <span>Private You own your data.</span>
          </div>
          <div className="feature">
            <i className="fas fa-infinity"></i>
            <span>Chain agnostic Forever yours.</span>
          </div>
        </div>
        {/* ✅ UPDATED: Direct link to Identity App */}
        <a href="https://banksystem.co/identity/" className="btn btn-gold">Mint Your ID</a>
      </div>
    </section>
  );
};

export default Identity;
